import * as React from 'react'; 
import { FormattedMessage } from 'react-intl';
import { VerificationService } from '@sheerid/jslib';

interface Props {
    verificationService: VerificationService;
}

const UploadInfoComponent: React.SFC<Props> = () => {

    return (
        <div>
            <span>
                <strong>
                    <FormattedMessage
                        id="step.docUpload.uploadInstructions"
                        defaultMessage="Upload your school-issued document that shows:"
                    />
                </strong>
            </span>
            <ul className="sid-upload-info-list">
                <li className="sid-upload-info-list__li">
                    <FormattedMessage
                        id="step.docUpload.uploadInfo.fullName"
                        defaultMessage="Your full name"
                    />
                </li>
                <li className="sid-upload-info-list__li">
                    <FormattedMessage
                        id="step.docUpload.uploadInfo.student.school"
                        defaultMessage="Your school"
                    />
                </li>
                <li className="sid-upload-info-list__li">
                    <FormattedMessage
                        id="step.docUpload.uploadInfo.student.enrollmentDate"
                        defaultMessage="Date proving enrollment for the current term (or within last 3 months)"
                    />
                </li>
            </ul>
        </div>
    );
};

export { UploadInfoComponent };
